import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

// ===== GLOBAL INTERCEPTOR PARA ADICIONAR clientIp EM REQUISIÇÕES PARA /claim =====
// Intercepta fetch() e XMLHttpRequest para adicionar clientIp automaticamente

// Backup dos métodos originais
const originalFetch = window.fetch.bind(window);
const originalXHROpen = (XMLHttpRequest.prototype.open as any).bind(XMLHttpRequest.prototype);
const originalXHRSend = (XMLHttpRequest.prototype.send as any).bind(XMLHttpRequest.prototype);

// Flag para rastrear se estamos buscando IP
let cachedIp: string | null = null;
let fetchingIp = false;

// Função para obter o IP
async function getClientIp(): Promise<string> {
  if (cachedIp) return cachedIp;
  if (fetchingIp) return ''; // Evita múltiplas requisições simultâneas
  
  fetchingIp = true;
  try {
    const response = await originalFetch('https://api.ipify.org?format=json');
    const data = await response.json();
    cachedIp = data.ip;
    console.log('[GlobalInterceptor] ✅ IP obtido:', cachedIp);
    return cachedIp || '';
  } catch (error) {
    console.error('[GlobalInterceptor] Erro ao obter IP:', error);
    return '';
  } finally {
    fetchingIp = false;
  }
}

// Interceptar fetch()
(window as any).fetch = function(resource: any, config?: any) {
  const url = typeof resource === 'string' ? resource : resource.toString();
  const method = (config?.method || 'GET').toUpperCase();
  
  // Se for POST para /claim, adicionar clientIp
  if (method === 'POST' && url.includes('/claim')) {
    console.log('[GlobalInterceptor] 🔍 Detectado fetch POST para /claim:', url);
    
    return getClientIp().then(ip => {
      const body = config?.body;
      
      if (body && typeof body === 'string') {
        try {
          const bodyObj = JSON.parse(body);
          bodyObj.clientIp = ip;
          const newConfig = { ...config, body: JSON.stringify(bodyObj) };
          console.log('[GlobalInterceptor] ✅ Adicionado clientIp ao fetch POST /claim');
          return originalFetch(resource, newConfig);
        } catch (e) {
          console.error('[GlobalInterceptor] Erro ao parsear body:', e);
          return originalFetch(resource, config);
        }
      }
      return originalFetch(resource, config);
    });
  }
  
  return originalFetch(resource, config);
};

// Interceptar XMLHttpRequest
(XMLHttpRequest.prototype.open as any) = function(this: any, method: string, url: string, ...args: any[]) {
  this._claimUrl = url;
  this._claimMethod = method.toUpperCase();
  if (this._claimMethod === 'POST' && url.includes('/claim')) {
    console.log('[GlobalInterceptor] 🔍 Detectado XMLHttpRequest POST para /claim:', url);
  }
  return originalXHROpen.call(this, method, url, ...args);
};

(XMLHttpRequest.prototype.send as any) = function(this: any, body?: any) {
  if (this._claimMethod === 'POST' && this._claimUrl?.includes('/claim') && body) {
    getClientIp().then((ip: string) => {
      try {
        let bodyObj = typeof body === 'string' ? JSON.parse(body) : body;
        if (bodyObj && typeof bodyObj === 'object') {
          bodyObj.clientIp = ip;
          const newBody = typeof body === 'string' ? JSON.stringify(bodyObj) : bodyObj;
          console.log('[GlobalInterceptor] ✅ Adicionado clientIp ao XMLHttpRequest POST /claim');
          return originalXHRSend.call(this, newBody);
        }
      } catch (e) {
        console.error('[GlobalInterceptor] Erro ao modificar body:', e);
        return originalXHRSend.call(this, body);
      }
    });
  } else {
    return originalXHRSend.call(this, body);
  }
};

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
